var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function joinNumberFormatParts(parts) {
    var e_1, _a;
    var joined = '';
    try {
        for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
            var part = parts_1_1.value;
            joined += part.value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return joined;
}
function applyNegativeNotation(absoluteValue, notation) {
    switch (notation) {
        case 'accounting':
            return "(".concat(absoluteValue, ")");
        default:
            return "-".concat(absoluteValue);
    }
}
function applyNegativeNotationToFormattedMoney(formatted, notation) {
    return __assign(__assign({}, formatted), { amount: applyNegativeNotation(formatted.amount, notation), full: applyNegativeNotation(formatted.full, notation) });
}
export function formatMoney(money, options) {
    if (options === void 0) { options = {}; }
    var _a = money.amount, amount = _a === void 0 ? '0' : _a, _b = money.currency, currency = _b === void 0 ? 'USD' : _b;
    var _c = options.locales, locales = _c === void 0 ? 'en-US' : _c, _d = options.negativeNotation, negativeNotation = _d === void 0 ? 'accounting' : _d, _e = options.numberFormatOptions, numberFormatOptions = _e === void 0 ? {} : _e, _f = options.shouldRoundToUnit, shouldRoundToUnit = _f === void 0 ? false : _f;
    var isCurrencyFirst = false;
    var currencySymbol = '';
    var formattedAmount = '';
    var full;
    var parsedAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    var absoluteAmount = Math.abs(parsedAmount !== null && parsedAmount !== void 0 ? parsedAmount : 0);
    var formatter = new Intl.NumberFormat(locales, __assign({ currency: currency !== null && currency !== void 0 ? currency : undefined, maximumFractionDigits: shouldRoundToUnit === true ? 0 : 2, minimumFractionDigits: shouldRoundToUnit === true ? 0 : 2, style: currency === null ? 'decimal' : 'currency' }, numberFormatOptions));
    if (typeof formatter.formatToParts === 'function') {
        var formattedParts = formatter.formatToParts(absoluteAmount);
        full = joinNumberFormatParts(formattedParts);
        var firstPart = formattedParts[0];
        var lastPart = formattedParts[formattedParts.length - 1];
        if (currency === null) {
            formattedAmount = full;
        }
        else if ((firstPart === null || firstPart === void 0 ? void 0 : firstPart.type) === 'currency') {
            isCurrencyFirst = true;
            currencySymbol = firstPart.value;
            formattedAmount = full.substring(currencySymbol.length).trim();
        }
        else if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.type) === 'currency') {
            currencySymbol = lastPart.value;
            formattedAmount = full.substring(0, full.length - currencySymbol.length).trim();
        }
    }
    else {
        // Polyfill formatToParts
        full = formatter.format(absoluteAmount);
        var currencySymbolMatch = /(^[^\d.,MmBb]+)|([^\d.,MmBb]+$)/.exec(full);
        if (currency === null || currencySymbolMatch === null) {
            formattedAmount = full;
        }
        else {
            var matched = currencySymbolMatch[0];
            isCurrencyFirst = currencySymbolMatch.index === 0;
            currencySymbol = matched.trim();
            formattedAmount =
                isCurrencyFirst === true
                    ? full.substring(matched.length).trim()
                    : full.substring(0, full.length - matched.length).trim();
        }
    }
    var formatted = {
        amount: formattedAmount,
        currencySymbol: currencySymbol,
        full: full,
        isCurrencyFirst: isCurrencyFirst,
    };
    return parsedAmount !== null && parsedAmount < 0
        ? applyNegativeNotationToFormattedMoney(formatted, negativeNotation)
        : formatted;
}
//# sourceMappingURL=formatMoney.js.map